"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UvApiAuth_1 = __importDefault(require("./UvApiAuth"));
var Help_1 = __importDefault(require("./Help"));
var portfolioSpec_1 = require("./portfolioSpec");
var UvPortfoliosApi = /** @class */ (function (_super) {
    __extends(UvPortfoliosApi, _super);
    function UvPortfoliosApi() {
        return _super.call(this) || this;
    }
    UvPortfoliosApi.prototype.get = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.instance.get("/portfolios/" + id)];
            });
        });
    };
    UvPortfoliosApi.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.instance.get("/portfolios/all")];
            });
        });
    };
    UvPortfoliosApi.prototype.getAllSimple = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.instance.get("/portfolios/all-simple")];
            });
        });
    };
    UvPortfoliosApi.prototype.getPortfolio = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var emptyPortfolio, portfolioDto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emptyPortfolio = portfolioSpec_1.getEmptyPortfolio();
                        return [4 /*yield*/, this.get(id)];
                    case 1:
                        portfolioDto = _a.sent();
                        return [2 /*return*/, Help_1.default.mergeObjects(emptyPortfolio, portfolioDto.json)];
                }
            });
        });
    };
    UvPortfoliosApi.prototype.getEmptyPortfolio = function () {
        return __awaiter(this, void 0, void 0, function () {
            var emptyPortfolio;
            return __generator(this, function (_a) {
                emptyPortfolio = portfolioSpec_1.getEmptyPortfolio();
                return [2 /*return*/, emptyPortfolio];
            });
        });
    };
    UvPortfoliosApi.prototype.upsertPortfolio = function (id, objData, property, currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.upsertGeneric(1, id, objData, property, currentStep)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UvPortfoliosApi.prototype.save = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/portfolios/save/" + id)];
                    case 1: return [2 /*return*/, _a.sent()]; //needed???? Just have a status on the object like buildings and set that in vue and upsert?
                }
            });
        });
    };
    //TODO:TD refactor all the ApiCode   
    UvPortfoliosApi.prototype.upsert = function (dto) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.instance.post("/portfolios/upsert", dto)];
            });
        });
    };
    UvPortfoliosApi.prototype.upsertGeneric = function (typeId, id, objData, property, currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            var dto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dto = {
                            id: id,
                            json: Help_1.default.deepCloneObject(objData),
                            property: property,
                            objectType: typeId,
                            currentStep: currentStep
                        };
                        return [4 /*yield*/, this.upsert(dto)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UvPortfoliosApi;
}(UvApiAuth_1.default));
exports.default = UvPortfoliosApi;
//# sourceMappingURL=UvPortfoliosApi.js.map